<template>
  <v-dialog :value="true" max-width="600" lazy @input="$emit('close')">
    <v-card>
      <v-toolbar color="primary" flat dense card dark>
        <v-toolbar-title>{{ $t('titles.global.exportUsers') }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <div>
          <v-layout wrap row pa-3>
            <v-flex xs12 px-2>
              <v-select
                v-model="contentType"
                :items="contentTypes"
                :label="$t('fields.global.outputFormat')"
              />
            </v-flex>
            <v-divider />
            <v-flex xs12 px-2>
              <user-filters
                v-model="filters"
                :menu="false"
                type-role="player"
              />
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="$emit('close')" />
        <v-btn small ripple color="primary" :loading="loading" @click="_export">
          {{ $t('action.buttons.export') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserFilters from '@/components/management/users/UserFilters.vue'

import { apiAxios, parseFilters } from '@/helpers'
import { getUserFilters } from '@/helpers/permissions'
export default {
  name: 'DialogExportUsers',
  components: {
    UserFilters,
  },

  data() {
    return {
      filters: {},
      contentType: 'xlsx',
      contentTypes: ['xlsx', 'xls', 'csv'],
      loading: false,
    }
  },

  methods: {
    _export() {
      let { body } = parseFilters(
        { filters: this.filters, pagination: {} },
        {},
        getUserFilters({})
      )
      body.noValidate = true
      body.contentType = this.contentType
      if (body.deleted) body.deleted = 'all'
      this.loading = true
      apiAxios
        .post('users/export', body, { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `users.${this.contentType}`) // or any other extension
          document.body.appendChild(link)
          link.click()
          this.$emit('close')
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
